module.exports = __webpack_public_path__ + "img/trennschalter_1_2_both_off.348ee732.png";